module.exports = __webpack_public_path__ + "01-logo-top.a5af69937e9387a3a555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/01-logo-top.png
// module id = 356
// module chunks = 1